/**
 * YEDEK BANDI — yalnızca ANORMALLİK varsa görünür (07 §4e).
 *
 *  - otomatik yedek kurulu ama yazılamıyor (bağlantı yenilenmeli / hata),
 *  - otomatik yedek KAPALI ve defter DOLU: veri yalnızca bu tarayıcıda,
 *  - eşitlemede ÇAKIŞMA: aynı kaydı iki cihaz da değiştirmiş, sonraki
 *    tutuldu (kaybeden sessizce gitmesin; ayrıntı Ayarlar'da). Kapatılabilir.
 *
 * İkincisi de bir anormallik: 27.09.2026'da tam bu durumda "Clear site data"
 * defteri sildi. Boş defterde bant yok — korunacak bir şey yok.
 *
 * DEĞİŞİKLİKTE OTOMATİK İNDİRME (gelen karar 03.11.2026) varken ikincisinin
 * yerini indirme bandı alır: yalnızca indirilmemiş değişiklik varsa görünür
 * (otomatik indirme çalışmıyor, açılışta bekleyen var ya da yalnızca ayarlar
 * değişti) ve aynı şifreli dosyayı tek dokunuşla indirir. Bu tarayıcıdaki ilk
 * otomatik indirmeden sonra "indi mi?" sorusu da burada — bir soru, uyarı
 * değil: uyarı rengi almaz.
 */

import { M } from "../dil";
import { useState } from "react";
import { useMutation } from "../repo/useAsync";
import { routeHref } from "../lib/router";
import { HEDEF_ADI } from "../yedek/tipler";
import { useYedek } from "../yedek/YedekSaglayici";
import { useOtoIndir } from "../yedek/OtoIndirSaglayici";
import { DEPOLAMA_ADRESI } from "./DepolamaSorusu";
import { Button, InlineError } from "../ui/primitives";

export function YedekBandi() {
  const y = useYedek();
  const o = useOtoIndir();
  const run = useMutation();
  const [kapatilan, setKapatilan] = useState<string | null>(null);
  if (y === null) return null;
  const { durum, defterBos } = y;

  const e = durum.esitleme;
  if (e !== null && e.cakismalar.length > 0 && kapatilan !== e.zaman) {
    return (
      <div role="status" className="flex flex-wrap items-center gap-2 border-b border-warn-border bg-warn-soft px-4 py-1.5 text-[12px] text-warn">
        <span>{M.yedek.bant.cakisma(e.cakismalar.length)}</span>
        <a className="underline" href={routeHref("ayarlar")}>
          {M.ortak.ayrinti}
        </a>
        <Button className="!py-0.5 text-[12px]" onClick={() => setKapatilan(e.zaman)}>
          {M.ortak.tamam}
        </Button>
      </div>
    );
  }

  if (durum.kurulu === true && durum.baglantiGerekli) {
    const metin =
      durum.hedefTuru === null ? M.yedek.bant.bekliyorBuluta : M.yedek.bant.bekliyorHedef(HEDEF_ADI[durum.hedefTuru]);
    return (
      <div role="status" className="flex flex-wrap items-center gap-2 border-b border-warn-border bg-warn-soft px-4 py-1.5 text-[12px] text-warn">
        <span>{metin}</span>
        <Button className="!py-0.5 text-[12px]" disabled={run.pending} onClick={() => void run.run(() => y.yenidenBaglan())}>
          {M.yedek.depolama.yenidenBaglan}
        </Button>
        {run.error !== undefined && <InlineError error={run.error} />}
      </div>
    );
  }
  if (durum.kurulu === true && durum.hata !== null) {
    return (
      <div role="status" className="border-b border-danger-border bg-danger-soft px-4 py-1.5 text-[12px] text-danger">
        {M.yedek.bant.yazilamadi(durum.hata.mesaj)}{" "}
        <a className="underline" href={routeHref("ayarlar")}>
          {M.yedek.bant.ayarlar}
        </a>
      </div>
    );
  }
  if (o !== null) {
    if (o.bulutBagli) return null;
    if (o.soru && o.son !== null) {
      return (
        <div role="status" className="flex flex-wrap items-center gap-2 border-b border-line bg-surface px-4 py-1.5 text-[12px] text-ink">
          <span>{M.yedek.bant.indiMi(o.son.dosya)}</span>
          <Button className="!py-0.5 text-[12px]" onClick={() => o.izinCevapla(true)}>
            {M.yedek.bant.indi}
          </Button>
          <Button className="!py-0.5 text-[12px]" onClick={() => o.izinCevapla(false)}>
            {M.yedek.bant.inmedi}
          </Button>
        </div>
      );
    }
    const veri = o.fark === "veri" && (!o.etkin || o.acilistaBekleyen || o.hata !== undefined);
    if (!veri && o.fark !== "ayar") return null;
    return (
      <div role="status" className="flex flex-wrap items-center gap-2 border-b border-warn-border bg-warn-soft px-4 py-1.5 text-[12px] text-warn">
        <span>{veri ? M.yedek.bant.indirilmemis : M.yedek.bant.ayarDegisti}</span>
        <Button className="!py-0.5 text-[12px]" disabled={run.pending} onClick={() => void run.run(() => o.indir())}>
          {M.yedek.bant.yedegiIndir}
        </Button>
        <a className="underline" href={DEPOLAMA_ADRESI}>
          {M.yedek.bant.ayarlarDepolama}
        </a>
        {o.hata !== undefined && <InlineError error={o.hata} />}
      </div>
    );
  }
  if (durum.kurulu === false && defterBos === false) {
    return (
      <div role="status" className="border-b border-warn-border bg-warn-soft px-4 py-1.5 text-[12px] text-warn">
        {M.yedek.bant.yalnizcaTarayicida}{" "}
        <a className="underline" href={routeHref("ayarlar")}>
          {M.yedek.bant.ayarlarDepolama}
        </a>
      </div>
    );
  }
  return null;
}
